<template>
  <div class="flex-container panel-head align-top mb-0">
    <div class="flex-item">
      <p>
        <span v-if="$hasFeature('packing_indent')">{{$t('INDENT_SCHEDULED_SHIPPING_DATE')}} :</span>
         <span v-else-if="configurations && configurations.is_datepicker_24H_enabled && (order && order.sources && order.sources[0] && order.sources[0].loading_date)">{{$t('INDENT_VEHICLE_REQUIREMENT_DATE')}} : <strong>{{$moment(order.sources[0].loading_date).format("DD-MM-YYYY | HH:mm")}}</strong> </span>
         <span v-else>{{$t('INDENT_VEHICLE_REQUIREMENT_DATE')}}:<strong>{{$moment(order.sources[0].loading_date).format("DD-MM-YYYY | hh:mm A")}}</strong> </span>
</p>
      <p v-if="order && order.sources && order.sources[0] && order.sources[0].details.name" >
        {{$t('INDENT_SHIPPED_FROM')}} : <strong> {{ shippedFrom }}</strong>
      </p>
      <p v-if="order && order.destinations && order.destinations[0].details.name">
        {{$t('INDENT_SHIPPED_TO')}} : <strong>{{ shippedTo }}</strong>
      </p>
      <p v-if="configurations && configurations.isShipmentNumberEnabled">
        {{$t('INDENT_SHIPMENT_NUMBER')}} : <strong>{{order.shipment_number}}</strong>
      </p>
      <p v-if="order && order.transporter && order.transporter.ref_id">
        {{$t('INDENT_TRANSPORTER')}} : <strong>{{order.transporter.ref_id}} - {{order.transporter.name}}</strong>
      </p>
      <p v-if="$hasFeature('vehicle_destination_depot_mapping') && order && order.vehicle && order.vehicle.material_type">
        {{$t('MDM_MATERIAL_TYPE')}} :
        <Tooltip
          popper-class="max-width"
          effect="dark"
          placement="bottom-start"
          :open-delay="200"
          :disabled="order.vehicle.material_type.length <= 30"
        >
          <div slot="content">{{ order.vehicle.material_type }}</div>
          <strong style="max-width:180px; display:inline-block; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; vertical-align:bottom; cursor:default;">{{ order.vehicle.material_type }}</strong>
        </Tooltip>
      </p>
      <p v-if="order && order.thirdPartyLr">
        {{$t('THIRD_PARTY_LR_NUMBER')}} : <strong>{{ order.thirdPartyLr }}</strong>
      </p>
      <p v-if="order.seal_number_at_source">
        {{$t('INDENT_SEAL_NUMBER')}} : <strong> {{ order.seal_number_at_source }} </strong>
      </p>
      <p v-if="order && order.distance">
        Distance : <strong>{{order.distance.value}} {{order.distance.unit}}</strong>
      </p>
      <p v-if="order && order.creation_reason && $hasFeature('capture_indent_creation_reason')">
        Indent Creation Reason : <strong>{{ order.creation_reason || '-' }}</strong>
      </p>
    </div>
    <div class="flex-item text-right">
      <template v-if="$hasFeature('packing_indent')">
        <p v-if="order.ship_pack_details">{{$t('INDENT_SHIP_METHOD')}} : <strong>{{order.ship_pack_details.method}}</strong></p>
        <p>{{$t('INDENT_CARRIER_TYPE')}} : <strong>{{order.transporter.name}}</strong></p>
        <p v-if="order.label_details && order.label_details.errors && order.label_details.errors.length && reshipError">Courier Error: <strong class="text-red">{{order.label_details.errors.toString()}}</strong></p>
      </template>
      <template v-else>
        <p>{{$t('INDENT_VEHICLE')}} : <strong> {{ (order.vehicle && order.vehicle.number) ? `${order.vehicle_type.name} - ${order.vehicle.number }` :  order.vehicle_type.name }} </strong></p>
        <p>{{$t('INDENT_DELIVERY_TYPE')}} : <strong>{{order.vehicle_type.type}}
          <template v-if="mode"> - {{mode}}</template>
        </strong></p>
        <p
          v-permission="['base_freight_view']" v-if="order.base_frieght">
          {{$t('INDENT_BASE_FREIGHT')}} : <strong class="text-green-medium">
          {{ currentClient.currency_icon }} {{ baseFreightCharge }}
        </strong>
        </p>
        <p v-if="order.ptl_info && order.ptl_info.no_of_materials">
          {{$t('INDENT_NO_OF_MATERIALS')}} :
          <strong>{{order.ptl_info.no_of_materials}}</strong>
        </p>
        <p v-if="order.ptl_info && order.ptl_info.material_weight">
          {{$t('INDENT_WEIGHT_KG')}} :
          <strong>{{order.ptl_info.material_weight}} KG</strong>
        </p>
        <p v-if="order.ptl_info && order.ptl_info.material_volume">
          {{$t('INDENT_VOLUME_TYPE')}} :
          <strong>{{getConvertedClientVolume(order.ptl_info.material_volume)}} {{preferredVolumeUnit}}</strong>
        </p>
      </template>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { vehicleTypeMode, LorryReceiptGenerationCategory } from 'pando-constants';
import { contractTypes } from '@/constants/order';
import { invert } from 'lodash';
import { freightUnitType } from 'pando-constants';
import { mapGetters } from 'vuex';
import VolumeFormulaConvertor from '../../../../common-v2/helpers/volume-formula-converter';

export default {
  props: ['order', 'configurations', 'baseFreightCharge'],
  data() {
    return {
      vehicleTypeMode,
      invertedVehicleTypeMode: invert(vehicleTypeMode),
      freightUnitType,
      LorryReceiptGenerationCategory,
      shippedFrom: this.order.sources[0].details.name,
      shippedTo: this.order.destinations[0].details.name,
    };
  },
  computed: {
    ...mapGetters({
      currentClient: 'app/currentClient',
    }),
    preferredVolumeUnit() {
      return this.$preferredVolumeUnit();
    },
    freightUnit() {
      const currUnit = this.order &&
      this.order.base_frieght && this.order.base_frieght.freight_unit;

      if (currUnit == null) return null;

      let unit = (contractTypes[currUnit - 1] && contractTypes[currUnit - 1].name) || '';

      if (currUnit === 8) {
        unit = '';
      }

      return unit;
    },
    reshipError() {
      return this.$statusUtil.getStatusIds(['re_ship_error']).includes(this.order.status);
    },
    mode() {
      return this.invertedVehicleTypeMode[this.order.vehicle_type.mode];
    },
  },
  methods: {
    getConvertedClientVolume(volume) {
      return new VolumeFormulaConvertor().revertToClient(this.preferredVolumeUnit, volume);
    },
  },
};
</script>

<style lang="scss" scoped>


.order{
  &-depot{
    margin:0 10px 20px 10px;
    .col-2:first-child {
      padding-left: 0;
    }
  }
}
</style>
